import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useCurrentModal } from '../../../components/modals/ModalsContext'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('routines')
  const {
    data: { id }
  } = useCurrentModal()

  const context = !!id && 'edit'
  const title = t('modalTitle', { context })

  return (
    <>
      <Title size="h4" color={COLORS.dark2} noMargin>
        {title}
      </Title>
      <Separator weight={2} />
    </>
  )
}

export default ModalHeader
